import { createContext } from 'react';
import _noop from 'lodash/noop';

export const UploadStatementsContext =
    createContext<UploadStatementsProviderValue>({
        entityRefreshState: {},
        failedIngestions: [],
        handleFiles: _noop,
        hasActiveUploads: false,
        ingestionFailureHistory: [],
        ingestionSuccessHistory: [],
        setEntityRefreshState: _noop,
        setIngestionFailureHistory: _noop,
        uploadTasks: [],
    });
